/**
 * Coppia territorio / cassa edile letta da Fenice (capitolato ottobre 2026, cap. 7).
 *
 * Tabella `territori` in sola lettura: la scrive solo l'aggiornamento da Fenice.
 * Gli id Fenice sono i campi `idTerritorio`/`idCassaEdile` delle righe Statini.
 * Dati puri, usabili anche dal client.
 */
import { z } from 'zod';

export const TerritorioSchema = z.object({
  id: z.number(),
  idTerritorioFenice: z.number(),
  idCassaEdileFenice: z.number(),
  territorio: z.string(),
  cassaedile: z.string(),
  /** false = coppia non più restituita da Fenice: resta per le deleghe che la usano */
  presenteFenice: z.boolean(),
  /** UTC, `YYYY-MM-DD HH:MM:SS` */
  aggiornatoAt: z.string(),
});

export type Territorio = z.infer<typeof TerritorioSchema>;

/** Riga dell'elenco Fenice da scrivere in `territori` */
export type TerritorioFenice = Pick<Territorio, 'idTerritorioFenice' | 'idCassaEdileFenice' | 'territorio' | 'cassaedile'>;

/** Esito dell'aggiornamento da Fenice */
export const EsitoAggiornamentoTerritoriSchema = z.object({
  totale: z.number(),
  nuove: z.number(),
  aggiornate: z.number(),
  nonPiuPresenti: z.number(),
});

export type EsitoAggiornamentoTerritori = z.infer<typeof EsitoAggiornamentoTerritoriSchema>;
